export const noSubject = "bdb";
export default {noSubject};